export const FORM_HEADER = "Mobile configuration";
export class MobileConfigConstants {
    static SAVE_BTN_TEXT_PLACEHOLDER = "Add";
    static EDIT_BUTTON_LABEL = "Edit";
    static FORM_HEADER = "Mobile configuration";
    static CREATE_MOBILE_CONFIG_TITLE = "Create Mobile configuration";
    static EDIT_MOBILE_CONFIG_TITLE = "Edit Mobile configuration";
}
export var MobileConfigHeadingEnum;
(function (MobileConfigHeadingEnum) {
    MobileConfigHeadingEnum["MinAppVersion"] = "Minimum Mobile App Version";
    MobileConfigHeadingEnum["MaxOfflineHours"] = "Maximum no. of hours offline";
    MobileConfigHeadingEnum["AllowOfflineAccess"] = "Allow offline access";
})(MobileConfigHeadingEnum || (MobileConfigHeadingEnum = {}));
export const mobileConfigHeadingLookup = new Map([
    [MobileConfigHeadingEnum.MinAppVersion, "minAppVersion"],
    [MobileConfigHeadingEnum.MaxOfflineHours, "maxOfflineHours"],
    [MobileConfigHeadingEnum.AllowOfflineAccess, "allowOfflineAccess"]
]);
